import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { firebase } from "../../models/firestore";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import TimePicker from "react-times";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-times/css/material/default.css";
// or you can use classic theme
import "react-times/css/classic/default.css";
//import klus from "./klus";
import "typeface-roboto";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  margin: {
    margin: theme.spacing.unit
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  formlabel: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
    color: "yellow"
  },
  menu: {
    width: 200
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "4px 4px",
    width: "calc(100% - 24px)",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      borderColor: "gold",
      //"#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      backgroundColor: "gold"
    }
  },
  ahdFormLabel: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 12,
    // color: "steelblue"
    //color:  "orange",
    color: "green"
  },
  ahdFormLabelGeslacht: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 10,
    color: "green",
    fontWeight: "700"
  },
  ahdInput: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 16,
    color: "blue",
    fontWeight: "400"
  },
  ahdRoot: {
    fontSize: 18,
    color: "blue"
  }
});

const klantarr = [];
firebase
  .firestore()
  .collection("klanten")
  .orderBy("achternaam")
  .get()
  .then(querysnapshot => {
    querysnapshot.docs.map(doc => {
      let naam = "";
      doc.data().tussenvoegsel === undefined
        ? (naam = doc.data().achternaam)
        : (naam =
            doc.data().tussenvoegsel.toLowerCase() +
            " " +
            doc.data().achternaam +
            " " +
            doc.data().initialen);

      klantarr.push({
        value: doc.id,
        label: naam + " " + doc.data().postcode
      });
      return null;
    });
  });

//klantarr.push({ value: "M.Aerts", label: "De Boer 1948AC" });
//console.log(klantarr.length);
//console.log('Klantarr', klantarr[0]);
//
let vrijwilligerarr = [];
let vasteadressenarr = [];

firebase
  .firestore()
  .collection("vrijwilligers")
  .orderBy("laatsteklus")
  .get()
  .then(querysnapshot => {
    //console.log("Ophalen vrijwilligers");

    querysnapshot.docs.map(doc => {
      let achternaamsamengesteld =
        doc.data().tussenvoegsel === undefined
          ? doc.data().achternaam
          : doc.data().tussenvoegsel.toLowerCase() +
            " " +
            doc.data().achternaam;
      let naam = doc.data().voornaam + " " + achternaamsamengesteld;

      vrijwilligerarr.push({
        value: doc.id,
        label: doc.data().backuptelefoon
          ? naam +
            " - " +
            doc.data().telefoon +
            " of " +
            doc.data().backuptelefoon
          : naam + " - " + doc.data().telefoon,
        email: doc.data().email,
        Chauffeur: doc.data().Chauffeur,
        ChauffeurInstellingen: doc.data().ChauffeurInstellingen,
        Boodschap: doc.data().Boodschap,
        Tuin: doc.data().Tuin,
        Electra: doc.data().Electra,
        Timmeren: doc.data().Timmeren,
        Wandelen: doc.data().Wandelen,
        Techniek: doc.data().Techniek,
        Lief_en_leed: doc.data().Lief_en_leed,
        Algemeneklusjes: doc.data().Algemeneklusjes,
        KlussenInstellingen: doc.data().KlussenInstellingen,
        PR: doc.data().PR,
        beschikbaarheid: doc.data().beschikbaarheid
      });
      return null;
    });
  });

firebase
  .firestore()
  .collection("vasteadressen")
  .orderBy("sorteerletter")
  .get()
  .then(querysnapshot => {
    //console.log('Ophalen vasteadressen');

    querysnapshot.docs.map(doc => {
      vasteadressenarr.push({
        value:
          doc.data().postcode +
          "*" +
          doc.data().huisnummer +
          "*" +
          doc.data().telefoon +
          "*" +
          doc.data().bestemmingnaaminstelling,
        label: doc.data().bestemmingnaaminstelling,
        bestemmingnaaminstelling: doc.data().bestemmingnaaminstelling,
        adres: doc.data().adres,
        huisnummer: doc.data().huisnummer,
        plaats: doc.data().plaats,
        postcode: doc.data().postcode,
        telefoon: doc.data().telefoon
      });
      return null;
    });
  })
  .then(ok => {
    //console.log(vasteadressenarr.length);
  });

// vrijwilligerarr.push({ value: 'Pierre de Boer', label: 'Pierre de Boer' });
// vrijwilligerarr.push({ value: 'Leo Albers', label: 'Leo Albers' });

let klusarr = [];
klusarr.push({ value: "Chauffeur", label: "Chauffeur" });
klusarr.push({
  value: "ChauffeurInstellingen",
  label: "Chauffeur instellingen"
});
klusarr.push({ value: "Boodschap", label: "Boodschap" });
klusarr.push({ value: "Tuin", label: "Tuin" });
klusarr.push({ value: "Electra", label: "Electra" });
klusarr.push({ value: "Techniek", label: "Techniek" });
klusarr.push({ value: "Timmeren", label: "Timmeren" });
klusarr.push({ value: "Wandelen", label: "Wandelen" });
klusarr.push({ value: "Lief_en_leed", label: "Lief en leed" });
klusarr.push({ value: "Algemeneklusjes", label: "Algemene klusjes" });
klusarr.push({ value: "KlussenInstellingen", label: "Klussen Instellingen" });
klusarr.push({ value: "PR", label: "PR" });

//klusarr = klusarr.sort();

//vrijwilligerarr.push ({value: 'Pierre de Boer', label: 'Pierre de Boer'})

//.then(console.log(klantarr));
//const klantarr = [{ value: "Jan", option: "Janssen" }];

// const klantarr = klanten.map(klant => {
//   klantarr.push({ label: klant.achternaam, value: klant.id });
// });

class OpdrachtForm extends React.Component {
  constructor(props) {
    super(props);
    const { focused } = props;
    let hour = "";
    let minute = "";

    this.state = {
      ophaaladres: "Onbekend",
      bestemming: "Onbekend",
      //typeopdracht: "",
      typeopdrachtgewijzigd: false,
      hour,
      minute,
      focused,
      opdrachtuitgevoerd: false
    };

    this.onFocusChange = this.onFocusChange.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.handleFocusedChange = this.handleFocusedChange.bind(this);
  }

  onTimeChange(options) {
    const { hour, minute, meridiem } = options;

    this.setState({ hour, minute, meridiem });
  }

  onFocusChange(focused) {
    // console.log(`onFocusChange: ${focused}`);
    this.setState({ focused });
  }

  handleFocusedChange() {
    const { focused } = this.state;
    this.setState({ focused: !focused });
  }

  handleChange = name => event => {
    //console.log(event);
    const { gebruikersNaam } = this.props;
    const docarr = [];
    //console.log(name);
    if (name === "instellingenadresvan") {
      //alert("instellingenadresvan " + event.target.value);
      const data = event.target.value.split("*");
      const postcode = data[0];
      const huisnummer = data[1];
      const telefoon = data[2];
      const instellingsnaam = data[3];
      document.getElementById("postcode_ophaal").value = postcode;
      this.setState({ postcode_ophaal: postcode });
      document.getElementById("huisnummer_ophaal").value = huisnummer;
      this.setState({ huisnummer_ophaal: huisnummer });
      document.getElementById("opmerking").value =
        document.getElementById("opmerking").value +
        " Naam instelling ophalen:" +
        instellingsnaam +
        " Telefoonnummer instelling: " +
        telefoon;
      this.setState({ opmerking: document.getElementById("opmerking").value });
      this.HaalAdresOp(
        document.getElementById("postcode_ophaal").value,
        document.getElementById("huisnummer_ophaal").value,
        true
      );
    }
    if (name === "instellingenadresnaar") {
      const data = event.target.value.split("*");
      const postcode = data[0];
      const huisnummer = data[1];
      const telefoon = data[2];
      const instellingsnaam = data[3];
      document.getElementById("postcode_bestemming").value = postcode;
      this.setState({ postcode_bestemming: postcode });
      document.getElementById("huisnummer_bestemming").value = huisnummer;
      this.setState({ huisnummer_bestemming: huisnummer });
      document.getElementById("opmerking").value =
        document.getElementById("opmerking").value +
        " Naam instelling bestemming: " +
        instellingsnaam +
        " Telefoonnummer instelling: " +
        telefoon;
      this.setState({ opmerking: document.getElementById("opmerking").value });
      this.HaalAdresOp(
        document.getElementById("postcode_bestemming").value,
        document.getElementById("huisnummer_bestemming").value,
        false
      );
    }

    if (name === "klantid") {
      //console.log("Klantid", event.target.value);
      //ophalen klant
      firebase
        .firestore()
        .collection("klanten")
        .doc(event.target.value)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            //let achternaam = doc.data().achternaam;
            let adres = doc.data().adres;
            let huisnummer = doc.data().huisnummer || "";
            let toevoegsel = doc.data().toevoegsel || "";
            //console.log(toevoegsel);
            let compleetadres = `${adres} ${huisnummer} ${toevoegsel}`;
            //console.log(compleetadres);
            docarr.push({
              initialen: doc.data().initialen || "",
              voornaam: doc.data().voornaam,
              achternaam: doc.data().achternaam || "",
              tussenvoegsel: doc.data().tussenvoegsel || "",
              adres: compleetadres,
              huisnummer: huisnummer,
              toevoegsel: toevoegsel,
              woonplaats: doc.data().woonplaats || "",
              postcode: doc.data().postcode,
              telefoon: doc.data().telefoon || "",
              herhaling: false,
              herhaling1week: false,
              herhaling2week: false,
              opdrachtuitgevoerd: false,
              opmerking: doc.data().opmerking || "",
              geslacht: doc.data().geslacht || ""

              //datumopdracht: new Date().toLocaleDateString('nl-NL')
            });
            //console.log(achternaam);
          } else {
            //console.log("Doc not found");
          }
        })
        .then(ok => {
          //console.log(docarr.length);
          //console.log('Eerste element', docarr[0]);
          this.setState(docarr[0]);
          //console.log(this.state);
        });
    }
    // if (name === "vrijwilliger") {
    //   document.getElementById("vrijwilliger").value = event.target.value;
    // }

    // if (name === "typeopdracht") {
    //   document.getElementById("typeopdracht").value = event.target.value;
    // }
    // if (name === "uitvoeringsdatum") {
    //   event.target.value = new date(event.target.value).toLocaleDateString(
    //     "nl-NL"
    //   );
    // }

    if (name === "vrijwilligerid") {
      firebase
        .firestore()
        .collection("vrijwilligers")
        .doc(event.target.value)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            //let achternaam = doc.data().achternaam;
            let achternaamsamengesteld =
              doc.data().tussenvoegsel === undefined
                ? doc.data().achternaam
                : doc.data().tussenvoegsel.toLowerCase() +
                  " " +
                  doc.data().achternaam;
            let naam = doc.data().voornaam + " " + achternaamsamengesteld;
            docarr.push({
              vrijwilliger: naam,
              emailvrijwilliger: doc.data().email
            });
            if (doc.data().beschikbaarheidsInfo) {
              if (doc.data().beschikbaarheidsInfo !== "") {
                toast.error(`Opmerking voor: ${naam}`, {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true
                });
                toast.success(`${doc.data().beschikbaarheidsInfo}`, {
                  position: "top-center",
                  autoClose: 15000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true
                });
              }
            }
            //console.log("Emailadres", doc.data().email);
          } else {
            console.log("Doc not found");
          }
        })
        .then(ok => {
          document.getElementById("vrijwilliger").value =
            docarr[0].vrijwilliger;
          this.setState(docarr[0]);
        });
    }

    if (name === "typeopdracht") {
      //console.log('Nieuwe klustype', event.target.value);
      document.getElementById("klustype").value = event.target.value;
      this.setState({ typeopdrachtgewijzigd: true, vrijwilliger: "" });
    }
    if (name === "uitvoeringsdatum") {
      this.setState({
        uitvoeringsdatumtimestamp: Date.parse(event.target.value),
        opdrachtuitgevoerd: false
      });
    }
    if (name === "eindeherhaling") {
      this.setState({
        eindeherhalingtimestamp: Date.parse(event.target.value)
      });
    }
    //console.log('Waarde', event.target.value);
    this.setState({
      [name]: event.target.value,
      zz_lastupdate_timestamp: Date.now(),
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  saveWijzigingen = () => {
    const { opdracht } = this.props;
    //console.log(this.state.klantid);

    //TODO
    // Converteer datumuitvoering naar timestamp voor query maximaal 1 week in beeld.
    // console.log(this.state);
    this.setState({ update: Date.now() });
    if (this.state.klantid !== undefined || "Achternaam" !== undefined) {
      this.setState();
      opdracht.update(this.state);
    } else {
      alert("U kunt pas opslaan als U een klant gekozen heeft.");
    }
  };
  // dupliceer = () => {
  //   console.log(this.state);
  //   const { opdracht, gebruikersNaam } = this.props;
  //   this.setState();
  //   //opdracht.update(this.state);
  //   alert('Dupliceren nog implementeren.');
  // };

  handleChangeCheckBox = name => event => {
    if (name === "opdrachtuitgevoerd") {
      this.setState({
        datumgereed: new Date().toISOString().substr(0, 10),
        opdrachtuitgevoerd: event.target.value
      });
    }

    if (name === "herhaling") {
      this.setState({
        geenenkelereis: !event.target.value,
        herhaling: event.target.value
      });
      // if (event.target.value === true) {
      //   //console.log("Herhaling", event.target.value);
      //   document.getElementById("geenenkelereis").value = false;
      // }
    }
    if (name === "geenenkelereis") {
      //alert("Wijziging");
      this.setState({
        geenenkelereis: event.target.value,
        herhaling: !event.target.value
      });
      // if (event.target.value === true) {
      //   document.getElementById("herhaling").value = false;
      // }
    }

    const { gebruikersNaam } = this.props;
    this.setState({
      [name]: !this.state[name],
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  componentDidMount() {
    const editable =
      this.props.gebruikersrollen.search("admin") > -1 ||
      this.props.gebruikersrollen.search("kantoor") > -1;

    this.setState({
      disabled: !editable,
      woonplaats: this.props.opdracht.data.woonplaats || "",
      geenenkelereis: this.props.opdracht.data.geenenkelereis || false,
      herhaling: this.props.opdracht.data.herhaling || false,
      herhaling1week: this.props.opdracht.data.herhaling1week || false,
      herhaling2week: this.props.opdracht.data.herhaling2week || false,
      opdrachtuitgevoerd: this.props.opdracht.data.opdrachtuitgevoerd || false,
      bestemming: this.props.opdracht.data.bestemming || "",
      ophaaladres: this.props.opdracht.data.ophaaladres || "",
      hour: this.props.opdracht.data.hour || 0,
      minute: this.props.opdracht.data.minute || 0,
      focused: false,
      typeopdracht: this.props.opdracht.data.typeopdracht
      //geslacht: this.props.opdracht.data.geslacht || null
      //tussenvoegsel: this.props.opdracht.data.tussenvoegsel || ''
    });
    if (!this.props.opdracht.data.hour) {
      toast.error(
        `Tijd is nog niet ingevuld!! U kunt nu geen vrijwilliger kiezen.`,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );
    }
    // if (this.props.opdracht) {
    //   this.setState({
    //     expanded: null,
    //     geslacht: this.props.opdracht.data.geslacht
    //   });
    // }
  }
  //APIAIzaSyBK26vpJZhQqa5Ff7x8qHB-PWlNDgOi61U
  //https://maps.googleapis.com/maps/api/distancematrix/json?units=metric&origins=${ophaalpostcode}&destinations=${bestemmingspostcode}&key=AIzaSyBK26vpJZhQqa5Ff7x8qHB-PWlNDgOi61U
  //https://developers.google.com/api-client-library/javascript/features/cors
  // HaalRitDetailsOp = (ophaalpostcode, bestemmingspostcode) => {
  //   let that = this;
  //   let oauthToken = null;
  //   let user = null;
  //   firebase
  //     .auth()
  //     .getRedirectResult()
  //     .then(function(result) {
  //       if (result.credential) {
  //         // This gives you a Google Access Token.
  //         oauthToken = result.credential.accessToken;
  //       }
  //       user = result.user;
  //       //console.log(oauthToken, user);
  //     });

  //   return null;
  //   // var user = gapi.auth2.getAuthInstance().currentUser.get();
  //   // var oauthToken = user.getAuthResponse().access_token;

  //   var HttpClient = function() {
  //     this.get = function(aUrl, aCallback) {
  //       var anHttpRequest = new XMLHttpRequest();
  //       anHttpRequest.onreadystatechange = function() {
  //         if (anHttpRequest.readyState === 4 && anHttpRequest.status === 200)
  //           aCallback(anHttpRequest.responseText);
  //       };

  //       anHttpRequest.open("GET", aUrl, true);
  //       anHttpRequest.setRequestHeader("Authorization", "Bearer " + oauthToken);
  //       // anHttpRequest.setRequestHeader('Access-Control-Allow-Origin', 'http://localhost:3000');
  //       anHttpRequest.send(null);
  //     };
  //   };
  //   var client = new HttpClient();
  //   client.get(
  //     `https://maps.googleapis.com/maps/api/distancematrix/json?units=metric&origins=${ophaalpostcode}&destinations=${bestemmingspostcode}&key=AIzaSyClXNTbTnmqJxoyomXp9jkNm4xzF4sRRxM`,
  //     function(response) {
  //       if (response) {
  //         let obj = JSON.parse(response);
  //         if (obj.response.docs[0]) {
  //           //console.log(obj);
  //         }
  //         // if (obj.response.docs[0]) {

  //         //   if (ophaaladres) {
  //         //     that.setState({ ophaaladres: obj.response.docs[0].weergavenaam });
  //         //   } else {
  //         //     that.setState({ bestemming: obj.response.docs[0].weergavenaam });
  //         //   }
  //         //   return obj.response.docs[0].weergavenaam;
  //         // } else {
  //         //   if (ophaaladres) {
  //         //     that.setState({ ophaaladres: 'Adres niet gevonden' });
  //         //   } else {
  //         //     that.setState({ bestemming: 'Adres niet gevonden' });
  //         //   }
  //         //   return 'Niet gevonden';
  //         // }
  //       }
  //     }
  //   );
  // };

  HaalAdresOp = (postcode, huisnummer, ophaaladres) => {
    let that = this;
    //console.log(postcode);
    postcode = postcode.replace(" ", "");
    var HttpClient = function() {
      this.get = function(aUrl, aCallback) {
        var anHttpRequest = new XMLHttpRequest();
        anHttpRequest.onreadystatechange = function() {
          if (anHttpRequest.readyState === 4 && anHttpRequest.status === 200)
            aCallback(anHttpRequest.responseText);
        };

        anHttpRequest.open("GET", aUrl, true);
        anHttpRequest.send(null);
      };
    };
    var client = new HttpClient();
    client.get(
      `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:${postcode}&fq=huisnummer:${huisnummer}`,
      function(response) {
        if (response) {
          let obj = JSON.parse(response);
          if (obj.response.docs[0]) {
            if (ophaaladres) {
              that.setState({
                ophaaladres: obj.response.docs[0].weergavenaam,
                postcode_ophaal: postcode,
                huisnummer_ophaal: huisnummer
              });
            } else {
              that.setState({
                bestemming: obj.response.docs[0].weergavenaam,
                postcode_bestemming: postcode,
                huisnummer_bestemming: huisnummer
              });
            }
            return obj.response.docs[0].weergavenaam;
          } else {
            if (ophaaladres) {
              that.setState({ ophaaladres: "Adres niet gevonden" });
            } else {
              that.setState({ bestemming: "Adres niet gevonden" });
            }
            return "Niet gevonden";
          }
        }
      }
    );
  };

  HaalPostCodeOp = (straatnaam, huisnummer, woonplaats) => {
    let that = this;
    var HttpClient = function() {
      this.get = function(aUrl, aCallback) {
        var anHttpRequest = new XMLHttpRequest();
        anHttpRequest.onreadystatechange = function() {
          if (anHttpRequest.readyState === 4 && anHttpRequest.status === 200)
            aCallback(anHttpRequest.responseText);
        };

        anHttpRequest.open("GET", aUrl, true);
        anHttpRequest.send(null);
      };
    };
    var client = new HttpClient();
    client.get(
      `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=straatnaam:${straatnaam}&fq=huisnummer:${huisnummer}&fq=woonplaatsnaam:${woonplaats}`,
      function(response) {
        if (response) {
          let obj = JSON.parse(response);
          if (obj.response.docs[0]) {
            //console.log(obj.response.docs[0].postcode);
            that.setState({
              postcodelookup: obj.response.docs[0].postcode
            });

            return obj.response.docs[0].weergavenaam;
          } else {
            that.setState({ postcodelookup: "Postcode niet gevonden" });

            return "Niet gevonden";
          }
        }
      }
    );
  };
  // ---------
  // let response = {
  //   response: {
  //     numFound: 1,
  //     start: 0,
  //     maxScore: 1.0905706,
  //     docs: [
  //       {
  //         bron: "BAG",
  //         woonplaatscode: "2458",
  //         type: "adres",
  //         woonplaatsnaam: "Heemskerk",
  //         huis_nlt: "11",
  //         openbareruimtetype: "Weg",
  //         gemeentecode: "0396",
  //         weergavenaam: "Wupperstraat 11, 1966XK Heemskerk",
  //         straatnaam_verkort: "Wupperstr",
  //         id: "adr-a3bcc9a7614c99b8f00760ff533dfd96",
  //         gemeentenaam: "Heemskerk",
  //         identificatie: "0396010001012083-0396200000012357",
  //         openbareruimte_id: "0396300000000416",
  //         provinciecode: "PV27",
  //         postcode: "1966XK",
  //         provincienaam: "Noord-Holland",
  //         centroide_ll: "POINT(4.6772966 52.49671295)",
  //         nummeraanduiding_id: "0396200000012357",
  //         adresseerbaarobject_id: "0396010001012083",
  //         huisnummer: 11,
  //         provincieafkorting: "NH",
  //         centroide_rd: "POINT(106790.803 501237.437)",
  //         straatnaam: "Wupperstraat",
  //         score: 1.0905706
  //       }
  //     ]
  //   }
  // };
  // console.log(JSON.parse(response));

  render() {
    const { classes, opdracht } = this.props;

    // ---
    const { hour, minute, focused } = this.state;

    const {
      geslacht,
      tussenvoegsel,
      achternaam,
      adres,
      huisnummer,
      postcode,
      woonplaats,
      telefoon,
      typeopdracht,
      uitvoeringsdatum,
      eindeherhaling,
      vrijwilliger,
      omschrijving,
      datumgereed,
      postcode_ophaal,
      huisnummer_ophaal,
      postcode_bestemming,
      huisnummer_bestemming,
      opmerking
    } = opdracht.data;

    const HeerMevrouw =
      geslacht === "Vrouw" ? "Mw. " : geslacht === "Man" ? "Dhr. " : "Dhr/Mw. ";
    //console.log(vrijwilligerarr.length);
    // console.log("Opdracht", );
    //vrijwilligerarr = vrijwilligerarr[0];
    //let filteredarr = [];
    var filteredarr = vrijwilligerarr.filter(function(vw) {
      if (vw[typeopdracht] === true) {
        let weekdag = new Date(uitvoeringsdatum).getDay();
        //console.log(weekdag);
        let dagdeel = "avond";
        //zondag = 0 moet 7 worden
        if (weekdag === 0) {
          weekdag = 7;
        }
        //weekdag = 3;
        //console.log(vw["beschikbaarheid"].avond[weekdag]);
        // ochtend
        try {
          // eslint-disable-next-line radix
          if (parseInt(hour) < 13) {
            dagdeel = "morgen";
            //console.log(dagdeel);
          }
          //middag
          // eslint-disable-next-line radix
          if (parseInt(hour) >= 12 && parseInt(hour) < 19) {
            dagdeel = "middag";
            // console.log(dagdeel);
            return vw[typeopdracht] === true;
          }
          if (dagdeel === "morgen" && vw["beschikbaarheid"].morgen[weekdag]) {
            //console.log("morgen");
            //console.log(dagdeel);
            return vw[typeopdracht] === true;
          }
          if (dagdeel === "middag" && vw["beschikbaarheid"].middag[weekdag]) {
            //console.log("middag");
            //console.log(dagdeel);
            return vw[typeopdracht] === true;
          }
          if (dagdeel === "avond" && vw["beschikbaarheid"].avond[weekdag]) {
            //console.log(weekdag);
            // console.log("avond", vw["beschikbaarheid"].avond[weekdag]);
            return vw[typeopdracht] === true;
          }
        } catch (error) {
          console.log(error);
          return vw[typeopdracht] === true;
        }

        //   ? vw[typeopdracht] === true && vw["beschikbaarheid"].morgen[weekdag]
        //   : vw[typeopdracht] === true && vw["beschikbaarheid"].middag[weekdag];
      }
      return vw[typeopdracht] === true;
      // console.log(filteredarr);
      // if (vrijwilligerarr.length === 0) {
      //   console.log("Geen vrijwilliger gevonden");
      //   // filteredarr.push({
      //   //   value: "01234",
      //   //   label: "Geen vrijwilliger gevonden"
      //   //   // email: doc.data().email,
      //   //   // Chauffeur: doc.data().Chauffeur,
      //   //   // ChauffeurInstellingen: doc.data().ChauffeurInstellingen,
      //   //   // Boodschap: doc.data().Boodschap,
      //   //   // Tuin: doc.data().Tuin,
      //   //   // Electra: doc.data().Electra,
      //   //   // Timmeren: doc.data().Timmeren,
      //   //   // Wandelen: doc.data().Wandelen,
      //   //   // Techniek: doc.data().Techniek,
      //   //   // Lief_en_leed: doc.data().Lief_en_leed,
      //   //   // Algemeneklusjes: doc.data().Algemeneklusjes,
      //   //   // KlussenInstellingen: doc.data().KlussenInstellingen,
      //   //   // PR: doc.data().PR,
      //   //   // beschikbaarheid: doc.data().beschikbaarheid
      //   // });
      // }
    });

    return (
      <div
        style={{
          backgroundColor: "#F4F4F4",
          borderRadius: 15,
          borderColor: "black",
          borderSize: "4px"
        }}
      >
        <form className={classes.container} autoComplete="off">
          {/* // Diverse kenmerken */}
          {adres === undefined && (
            <FormControl
              className={classes.textField}
              style={{ marginTop: 15, color: "Orange" }}
              variant="outlined"
            >
              <InputLabel htmlFor="klant-helper" className={classes.textField}>
                Zoek klant
              </InputLabel>
              <Select
                native
                value={this.state.klantid}
                onChange={this.handleChange("klantid")}
                input={
                  <OutlinedInput
                    name="age"
                    labelWidth={this.state.labelWidth}
                    id="outlined-age-native-simple"
                  />
                }
              >
                <option value="" />
                {klantarr.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </FormControl>

            // <TextField
            //   id="klant"
            //   disabled={this.state.disabled}
            //   variant="outlined"
            //   select
            //   label="Kies de klant"
            //   className={classes.textField}
            //   value={this.state.klantid}
            //   onChange={this.handleChange("klantid")}
            //   InputLabelProps={{
            //     shrink: true,
            //     className: classes.ahdFormLabel
            //   }}
            //   SelectProps={{
            //     MenuProps: {
            //       className: classes.menu
            //     }
            //   }}
            //   //helperText="Kies de klant bij deze opdracht"
            //   margin="normal"
            // >
            //   {klantarr.map(option => (
            //     <MenuItem key={option.value} value={option.value}>
            //       {option.label}
            //     </MenuItem>
            //   ))}
            // </TextField>
          )}
          <TextField
            id="klusid"
            disabled={this.state.disabled}
            variant="outlined"
            select
            label="Kies type opdracht"
            className={classes.textField}
            defaultValue={this.state.typeopdracht}
            onChange={this.handleChange("typeopdracht")}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
            SelectProps={{
              MenuProps: {
                className: classes.menu
              }
            }}
            //helperText="Kies het type van deze opdracht"
            margin="normal"
          >
            {klusarr.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
                style={{
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "normal",
                  fontSize: 16
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          {typeopdracht !== "Nieuwe opdracht" &&
            !this.state.typeopdrachtgewijzigd && (
              <TextField
                id="vrijwilligerid"
                disabled={this.state.disabled}
                variant="outlined"
                select
                style={{ width: 500 }}
                label="Kies vrijwilliger voor"
                className={classes.textField}
                value={this.state.vrijwilliger}
                onChange={this.handleChange("vrijwilligerid")}
                InputLabelProps={{
                  shrink: true,
                  className: classes.ahdFormLabel
                }}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu
                  }
                }}
                //helperText="Kies de vrijwilliger bij deze opdracht"
                margin="normal"
              >
                {filteredarr.map(option => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    style={{
                      backgroundColor:
                        option.value.indexOf("Pierre") > -1 ? "grey" : "black",
                      color: "white",
                      fontWeight: "normal",
                      fontSize: 18
                    }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          <Button
            variant="contained"
            //color="default"
            style={{
              backgroundColor: "green",
              color: "white",
              paddingLeft: "1%",
              marginLeft: 50,
              marginTop: 17,
              height: 40
            }}
            onClick={this.saveWijzigingen}
          >
            Bewaar wijzigingen - sluit venster
          </Button>
          <span>
            {this.props.gebruikersrollen.search("afmelden") > -1 &&
              this.state.hour > 0 && (
                <FormControlLabel
                  labelPlacement="end"
                  control={
                    <Checkbox
                      checked={this.state.opdrachtuitgevoerd === true}
                      onChange={this.handleChangeCheckBox("opdrachtuitgevoerd")}
                      value="opdrachtuitgevoerd"
                      color="primary"
                    />
                  }
                  label={
                    this.state.opdrachtuitgevoerd
                      ? "Opdracht uitgevoerd"
                      : "Opdracht staat open"
                  }
                  style={{
                    marginTop: "10px",
                    marginLeft: "10px",
                    backgroundColor: this.state.opdrachtuitgevoerd
                      ? "lightgreen"
                      : "salmon",
                    color: this.state.opdrachtuitgevoerd ? "black" : "white",
                    borderRadius: 10,
                    paddingRight: 8
                  }}
                />
              )}

            {datumgereed &&
              this.state.opdrachtuitgevoerd && (
                <TextField
                  variant="outlined"
                  disabled={this.state.disabled}
                  //disabled={true}
                  id="datumgereed"
                  label="Datum gereed gemeld"
                  type="date"
                  defaultValue={
                    datumgereed || new Date().toLocaleDateString("nl-NL")
                  }
                  className={classes.textField}
                  style={{ marginTop: "10px", marginBottom: "10px" }}
                  onChange={this.handleChange("datumgereed")}
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.ahdFormLabel
                  }}
                />
              )}
          </span>
          <div style={{ width: "100%" }}>
            {/* <TextField
            disabled={this.state.disabled}
            id="initialen"
            label="Initialen"
            defaultValue={initialen || ''}
            onChange={this.handleChange('initialen')}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              //shrink: true,
              className: classes.ahdFormLabel
            }}
          /> */}
            {/* <TextField
            required
            disabled={this.state.disabled}
            id="voornaam"
            label="Voornaam"
            className={classes.textField}
            defaultValue={voornaam || ""}
            onChange={this.handleChange("voornaam")}
            margin="normal"
            // InputProps={{
            //   disableUnderline: true,
            //   classes: {
            //     root: classes.bootstrapRoot,
            //     input: classes.bootstrapInput
            //   }
            // }}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            disabled={this.state.disabled}
            id="tussenvoegsel"
            label="Tussenvoegsel"
            defaultValue={tussenvoegsel || ""}
            className={classes.textField}
            onChange={this.handleChange("tussenvoegsel")}
            margin="normal"
            // InputLabelProps={{
            //   shrink: true,
            //   className: classes.bootstrapFormLabel
            // }}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          /> */}
            <TextField
              required
              disabled
              id="achternaam"
              label="Naam"
              value={
                tussenvoegsel
                  ? HeerMevrouw + tussenvoegsel + "  " + achternaam
                  : HeerMevrouw + achternaam || ""
              }
              //onChange={this.handleChange("achternaam")}
              className={classes.textField}
              margin="normal"
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
            <TextField
              required
              disabled
              id="adres"
              label="Adres"
              defaultValue={adres}
              //onChange={this.handleChange('adres')}
              className={classes.textField}
              margin="normal"
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
            <TextField
              required
              disabled
              id="postcode"
              label="Postcode"
              defaultValue={postcode || ""}
              onChange={this.handleChange("postcode")}
              className={classes.textField}
              margin="normal"
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
            <TextField
              required
              disabled
              id="woonplaats"
              label="Woonplaats"
              defaultValue={woonplaats || "Heemskerk"}
              onChange={this.handleChange("woonplaats")}
              className={classes.textField}
              margin="normal"
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
            <TextField
              required
              disabled
              id="telefoonnummer"
              label="Telefoonnummer"
              defaultValue={telefoon || ""}
              onChange={this.handleChange("telefoon")}
              className={classes.textField}
              margin="normal"
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
            <TextField
              disabled
              id="datumopdracht"
              label="Datum opdracht"
              //type="date"
              // defaultValue={
              //   new Date(datumopdracht).toLocaleString("nl-NL") ||
              //   new Date().toLocaleDateString("nl-NL")
              // }
              defaultValue={
                new Date(opdracht.data.datumopdracht).toLocaleDateString(
                  "nl-NL"
                ) || new Date().toLocaleDateString("nl-NL")
              }
              className={classes.textField}
              style={{ marginTop: "18px" }}
              onChange={this.handleChange("datumopdracht")}
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
          </div>
          <div>
            <TextField
              disabled={this.state.disabled}
              id="uitvoeringsdatum"
              variant="outlined"
              label="Datum uitvoering"
              type="date"
              //value={uitvoeringsdatum || new Date()}
              defaultValue={uitvoeringsdatum || new Date()}
              className={classes.textField}
              style={{ marginTop: "18px" }}
              onChange={this.handleChange("uitvoeringsdatum")}
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />

            <TextField
              disabled={true}
              id="vrijwilliger"
              label="Vrijwilliger"
              defaultValue={vrijwilliger || ""}
              className={classes.textField}
              style={{ marginTop: "18px" }}
              onChange={this.handleChange("vrijwilliger")}
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.ahdFormLabel
              }}
            />
            <TextField
              disabled={this.state.disabled}
              id="klustype"
              label="Klus type"
              defaultValue={typeopdracht || ""}
              className={classes.textField}
              style={{ marginTop: "18px" }}
              onChange={this.handleChange("typeopdracht")}
              InputProps={{
                classes: {
                  root: classes.ahdRoot,
                  input: classes.ahdInput
                }
              }}
              InputLabelProps={{
                shrink: true
                //className: classes.ahdFormLabel
              }}
            />

            {/* <hr /> */}
            <FormControl
              disabled={this.state.disabled}
              className={classes.ahdformlabel}
              variant="outlined"
            >
              <FormLabel
                //component="legend"
                style={{ marginTop: "20px" }}
                className={classes.ahdFormLabelGeslacht}
              >
                Herhaalde opdracht of enkelvoudige retourrit opties.
              </FormLabel>

              <FormGroup row variant="outlined">
                <FormControlLabel
                  labelPlacement="end"
                  control={
                    <Checkbox
                      checked={this.state.herhaling === true}
                      onChange={this.handleChangeCheckBox("herhaling")}
                      value="herhaling"
                      color="primary"
                      id="herhaling"
                    />
                  }
                  label="Ja"
                />
                <FormControlLabel
                  labelPlacement="end"
                  control={
                    <Checkbox
                      checked={this.state.herhaling1week === true}
                      onChange={this.handleChangeCheckBox("herhaling1week")}
                      value="herhaling1week"
                      color="primary"
                    />
                  }
                  label="Elke week"
                />
                <FormControlLabel
                  labelPlacement="end"
                  control={
                    <Checkbox
                      checked={this.state.herhaling2week === true}
                      onChange={this.handleChangeCheckBox("herhaling2week")}
                      value="herhaling2week"
                      color="primary"
                    />
                  }
                  label="Elke 2 weken"
                />
                <FormControlLabel
                  labelPlacement="end"
                  control={
                    <Checkbox
                      checked={this.state.geenenkelereis === true}
                      onChange={this.handleChangeCheckBox("geenenkelereis")}
                      value="geenenkelereis"
                      color="primary"
                    />
                  }
                  label="Geen enkele reis
                  "
                  style={{
                    backgroundColor: "lightgreen",
                    borderRadius: 10,
                    paddingRight: 8
                  }}
                />
              </FormGroup>
            </FormControl>
            {this.state.herhaling === true && (
              <TextField
                variant="outlined"
                disabled={this.state.disabled}
                id="eindeherhaling"
                label="Laatste herhaling"
                type="date"
                defaultValue={
                  eindeherhaling || new Date().toLocaleDateString("nl-NL")
                }
                className={classes.textField}
                style={{ marginTop: "28px" }}
                onChange={this.handleChange("eindeherhaling")}
                InputProps={{
                  classes: {
                    root: classes.ahdRoot,
                    input: classes.ahdInput
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.ahdFormLabel
                }}
              />
            )}

            {typeopdracht !== "Nieuwe opdracht" && (
              <div
                style={{
                  width: "30%",
                  borderColor: "gold",
                  borderWidth: "4px",
                  borderRadius: 25
                }}
              >
                <TimePicker
                  style={{}}
                  trigger={this.trigger}
                  {...this.props}
                  colorPalette="light"
                  theme="material"
                  withoutIcon={true}
                  focused={focused}
                  onFocusChange={this.onFocusChange}
                  onTimeChange={this.onTimeChange}
                  time={hour && minute ? `${hour}:${minute}` : null}
                />
              </div>
            )}
          </div>
          {/* {typeopdracht.startsWith("Chauffeur") &&
          bestemming &&
          ophaaladres &&
          !retourgeboekt && (
            <Button
              style={{
                borderRadius: 4,
                borderSize: 2,
                borderColor: "Black",
                backgroundColor: "Orange",
                color: "White"
              }}
              onClick={() => alert("Maak retouropdracht nog implementeren")}
            >
              Maak retouropdracht
            </Button>
          )} */}
          {typeopdracht !== "Chauffeur" &&
            typeopdracht !== "Nieuwe opdracht" &&
            typeopdracht !== "ChauffeurInstellingen" && (
              <div style={{ width: "100%" }} className={classes.root}>
                <TextField
                  disabled={this.state.disabled}
                  className={this.props.classes.textField}
                  variant="outlined"
                  multiline
                  rows="4"
                  id="omschrijving"
                  label="Omschrijf de klus"
                  defaultValue={omschrijving || ""}
                  //className={classes.textField}
                  style={{ marginTop: "18px", width: "100%" }}
                  onChange={this.handleChange("omschrijving")}
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    //shrink: true,
                    className: classes.ahdFormLabel
                  }}
                />
              </div>
            )}
          {typeopdracht === "Nieuwe opdracht" && (
            <div>
              <h4>
                Sla eerste de opdracht op als je de klant en type opdracht hebt
                gekozen. Daarna kan je de opdracht nogmaals openen en bewerken.
              </h4>
            </div>
          )}
          {(typeopdracht === "Chauffeur" ||
            typeopdracht === "ChauffeurInstellingen") && (
            <div style={{ width: "100%" }} className={classes.root}>
              <table>
                <tbody>
                  <tr>
                    <td>Ophalen van:</td>

                    <td style={{ height: 50 }}>
                      {" "}
                      <TextField
                        required
                        disabled={this.state.disabled}
                        id="postcode_ophaal"
                        label="Postcode ophaaladres"
                        defaultValue={postcode_ophaal || postcode}
                        onChange={this.handleChange("postcode_ophaal")}
                        className={classes.textField}
                        margin="normal"
                        InputProps={{
                          classes: {
                            root: classes.ahdRoot,
                            input: classes.ahdInput
                          }
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.ahdFormLabel
                        }}
                      />
                    </td>
                    <td>
                      <TextField
                        required
                        disabled={this.state.disabled}
                        id="huisnummer_ophaal"
                        label="Huisnummer ophaaladres"
                        defaultValue={huisnummer_ophaal || huisnummer}
                        onChange={this.handleChange("huisnummer_ophaal")}
                        className={classes.textField}
                        margin="normal"
                        InputProps={{
                          classes: {
                            root: classes.ahdRoot,
                            input: classes.ahdInput
                          }
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.ahdFormLabel
                        }}
                      />
                    </td>
                    <td>
                      <Button
                        style={{
                          borderRadius: 4,
                          borderSize: 2,
                          borderColor: "Black",
                          backgroundColor: "Green",
                          color: "White",
                          marginTop: 25
                        }}
                        onClick={() =>
                          this.HaalAdresOp(
                            document.getElementById("postcode_ophaal").value,
                            document.getElementById("huisnummer_ophaal").value,
                            true
                          )
                        }
                      >
                        Haal adres op
                      </Button>
                      <TextField
                        id="instellingen"
                        disabled={this.state.disabled}
                        variant="outlined"
                        select
                        label="Kies instellingsadres ophalen"
                        className={classes.textField}
                        value={this.state.vrijwilliger}
                        onChange={this.handleChange("instellingenadresvan")}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.ahdFormLabel
                        }}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        //helperText="Kies de vrijwilliger bij deze opdracht"
                        margin="normal"
                      >
                        {vasteadressenarr.map(option => (
                          <MenuItem
                            key={option.value}
                            value={option.value}
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              fontWeight: "normal",
                              fontSize: 14
                            }}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </td>
                    <td>{this.state.ophaaladres}</td>
                  </tr>
                  <tr>
                    <td>Naar:</td>

                    <td>
                      {" "}
                      <TextField
                        required
                        disabled={this.state.disabled}
                        id="postcode_bestemming"
                        label="Postcode bestemming"
                        defaultValue={postcode_bestemming || ""}
                        onChange={this.handleChange("postcode_bestemming")}
                        className={classes.textField}
                        margin="normal"
                        InputProps={{
                          classes: {
                            root: classes.ahdRoot,
                            input: classes.ahdInput
                          }
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.ahdFormLabel
                        }}
                      />
                    </td>
                    <td>
                      {" "}
                      <TextField
                        required
                        disabled={this.state.disabled}
                        id="huisnummer_bestemming"
                        label="Huisnummer bestemming"
                        defaultValue={huisnummer_bestemming || ""}
                        onChange={this.handleChange("huisnummer_bestemming")}
                        className={classes.textField}
                        margin="normal"
                        InputProps={{
                          classes: {
                            root: classes.ahdRoot,
                            input: classes.ahdInput
                          }
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.ahdFormLabel
                        }}
                      />
                    </td>
                    <td>
                      {" "}
                      <Button
                        style={{
                          borderRadius: 4,
                          borderSize: 2,
                          borderColor: "Black",
                          backgroundColor: "Green",
                          color: "White",
                          marginTop: 25
                        }}
                        onClick={() =>
                          this.HaalAdresOp(
                            document.getElementById("postcode_bestemming")
                              .value,
                            document.getElementById("huisnummer_bestemming")
                              .value,
                            false
                          )
                        }
                      >
                        Haal adres op:
                      </Button>
                      <TextField
                        id="instellingen"
                        disabled={this.state.disabled}
                        variant="outlined"
                        select
                        label="Kies instellingsadres bestemming"
                        className={classes.textField}
                        value={this.state.vrijwilliger}
                        onChange={this.handleChange("instellingenadresnaar")}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.ahdFormLabel
                        }}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu
                          }
                        }}
                        //helperText="Kies de vrijwilliger bij deze opdracht"
                        margin="normal"
                      >
                        {vasteadressenarr.map(option => (
                          <MenuItem
                            key={option.value}
                            value={option.value}
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              fontWeight: "normal",
                              fontSize: 14
                            }}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </td>
                    <td>{this.state.bestemming}</td>
                  </tr>
                  <tr />
                  {/* <tr>
                    <td>
                      {" "}
                      <Button
                        style={{
                          borderRadius: 4,
                          borderSize: 2,
                          borderColor: "Black",
                          backgroundColor: "Green",
                          color: "White"
                        }}
                        onClick={() =>
                          this.HaalRitDetailsOp(
                            document.getElementById("postcode_ophaal").value,
                            document.getElementById("postcode_bestemming")
                              .value,
                            false
                          )
                        }
                      >
                        Haal ritdetails op
                      </Button>
                    </td>
                  </tr> */}
                </tbody>
              </table>
              <hr />
              <div
                style={{ width: "100%", marginTop: "10px" }}
                className={classes.root}
              >
                <h5>Postcodezoeker: </h5>
                <TextField
                  disabled={false}
                  className={this.props.classes.textField}
                  id="zk_straatnaam"
                  label="Straatnaam"
                  defaultValue={""}
                  //className={classes.textField}
                  //style={{ marginTop: "18px", width: "100%" }}
                  // onChange={this.handleChange("opmerking")}
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.ahdFormLabel
                  }}
                  variant="outlined"
                />
                <TextField
                  disabled={false}
                  className={this.props.classes.textField}
                  id="zk_huisnummer"
                  label="Huisnummer"
                  defaultValue={""}
                  //className={classes.textField}
                  //style={{ marginTop: "18px", width: "100%" }}
                  // onChange={this.handleChange("opmerking")}
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.ahdFormLabel
                  }}
                  variant="outlined"
                />
                <TextField
                  disabled={false}
                  className={this.props.classes.textField}
                  id="zk_woonplaats"
                  label="Woonplaats"
                  defaultValue={""}
                  //className={classes.textField}
                  //style={{ marginTop: "18px", width: "100%" }}
                  // onChange={this.handleChange("opmerking")}
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.ahdFormLabel
                  }}
                  variant="outlined"
                />
                {this.state.postcodelookup && (
                  <Button
                    style={{
                      backgroundColor: "Blue",
                      borderColor: "White",
                      borderSize: "2px",
                      borderRadius: "4",
                      marginRight: "15px",
                      marginLeft: "15px",
                      //marginTop: "10px",
                      color: "white",
                      fontSize: 24,
                      fontWeight: "bold"
                    }}
                  >
                    {this.state.postcodelookup}
                  </Button>
                )}

                {/* <TextField
                disabled={true}
                className={this.props.classes.textField}
                id="postcodelookup"
                label="Gevonden postcode"
                defaultValue={this.state.postcodelookup}
                //className={classes.textField}
                //style={{ marginTop: "18px", width: "100%" }}
                // onChange={this.handleChange("opmerking")}
                InputProps={{
                  classes: {
                    root: classes.ahdRoot,
                    input: classes.ahdInput
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.ahdFormLabel
                }}
                variant="outlined"
              /> */}
                <Button
                  style={{
                    borderRadius: 4,
                    borderSize: 2,
                    borderColor: "Black",
                    backgroundColor: "Green",
                    color: "White"
                  }}
                  onClick={() =>
                    this.HaalPostCodeOp(
                      document.getElementById("zk_straatnaam").value,
                      document.getElementById("zk_huisnummer").value,
                      document.getElementById("zk_woonplaats").value
                    )
                  }
                >
                  Zoek postcode
                </Button>
                {/* <Button
                  style={{
                    marginLeft: 20,
                    borderRadius: 4,
                    borderSize: 2,
                    borderColor: "Black",
                    backgroundColor: "Gold",
                    color: "black"
                  }}
                  onClick={() => alert(this.state.adressen)}
                >
                  Toon instellingen adressen
                </Button> */}
              </div>

              <div style={{ width: "100%" }} className={classes.root}>
                <TextField
                  disabled={this.state.disabled}
                  className={this.props.classes.textField}
                  multiline
                  rows="4"
                  id="opmerking"
                  label="Opmerkingen"
                  defaultValue={opmerking || ""}
                  //className={classes.textField}
                  style={{ marginTop: "5px", width: "100%" }}
                  onChange={this.handleChange("opmerking")}
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    //shrink: true,
                    className: classes.ahdFormLabel
                  }}
                  variant="outlined"
                />
              </div>
            </div>
          )}
          {/* <FormControl
          disabled={this.state.disabled}
          className={classes.ahdformlabel}
          style={{ marginTop: "20px" }}
        >
          <FormLabel
            //component="legend"
            className={classes.ahdFormLabelGeslacht}
          >
            Geslacht
          </FormLabel>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.geslacht === "Man"}
                  onChange={this.handleChange("geslacht")}
                  value="Man"
                  color="primary"
                />
              }
              label="Man"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.geslacht === "Vrouw"}
                  onChange={this.handleChange("geslacht")}
                  value="Vrouw"
                />
              }
              label="Vrouw"
            />
          </FormGroup>
        </FormControl> */}
          {/* <Paper
          style={{
            marginTop: '50px',
            marginLeft: '200px',
            marginRight: '200px'
          }}
        >
          <ul>
            De rollen admin en kantoor kunnen het formulier verder bewerken. Voor alle andere rollen is dit formulier op
            dit moment niet bewerkbaar
          </ul>
        </Paper> */}
          <Button
            variant="contained"
            //color="default"
            style={{
              marginTop: 10,
              backgroundColor: "green",
              color: "white",
              height: 40,
              paddingLeft: "70%"
            }}
            onClick={this.saveWijzigingen}
          >
            Bewaar wijzigingen - sluit venster
          </Button>

          {/* {this.state.herhaling === true && (
          <Button
            variant="contained"
            //color="default"
            style={{
              backgroundColor: "orange",
              color: "white",
              paddingLeft: "70%",
              marginTop: 20
            }}
            onClick={this.dupliceer}
          >
            Dupliceer deze opdracht
          </Button>
        )} */}
        </form>
      </div>
    );
  }
}

OpdrachtForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OpdrachtForm);



// WEBPACK FOOTER //
// ./src/components/Opdrachten/OpdrachtForm.jsx